module.exports = __webpack_public_path__ + "static/img/title02.713146a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title02.png
// module id = PsPR
// module chunks = 18